"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() { }; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BundleSelector = /*#__PURE__*/function () {
    function BundleSelector(el) {
        var _this = this;

        _classCallCheck(this, BundleSelector);

        this.combos = [['Au', 'Ho', 'Li', 'Mo', 'RV'], ['Au', 'Re', 'Li', 'Mo', 'RV']];
        this.bundler = el;

        if ($(el).hasClass('t1-mobile')) {
            this.type = 'mobile';
        } else if ($(el).hasClass('t1-v1')) {
            this.type = 'v1';
        } else {
            this.type = 'v2';
        }

        if (this.type != 'mobile') {
            $(el).find('select').prop('selectedIndex', 0);
        }

        if (this.type == 'mobile' || this.type == 'v1') {
            this.optionsMap = new Map();
            this.allOptions = [];
            this.allValues = [];
            $(el).find('option').map(function (i, e) {
                _this.optionsMap.set($(e).val(), $(e).text());

                _this.allOptions.push($(e).val());

                _this.allValues.push($(e).text());
            });
            this.allClasses = this.allOptions.join(' ');
            $(el).find('select.t1-bundle-select').off('change').on('change', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var ect = e.currentTarget;

                if ($(ect).is('.t1-bundle-container:first-child select.t1-bundle-select')) {
                    $(ect).closest('.t1').find('.t1-bundle-container').not(':first-child').remove();
                }

                $(ect).removeClass(_this.allClasses);
                $(ect).addClass($(ect).val());

                _this.updateOptions();
            });
            $(el).find('select.t1-add-product').off('change').on('change', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var $this = $(e.currentTarget);

                if ($this.val() != "") {
                    var container = $this.closest('.t1-bundle-container');
                    var newSelect = container.clone(true);
                    newSelect.find('select').val($this.val()).removeClass(_this.allClasses).addClass($this.val());
                    $(container).after(newSelect);

                    _this.updateOptions();
                }
            });
        } else {
            this.optionsMap = new Map();
            this.allOptions = [];
            this.allValues = [];
            $(el).find('option').map(function (i, e) {
                _this.optionsMap.set($(e).val(), $(e).text());

                _this.allOptions.push($(e).val());

                _this.allValues.push($(e).text());
            });
            this.allClasses = this.allOptions.join(' ');
            $(el).find('select.t1-bundle-select').off('change').on('change', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var ect = e.currentTarget;
                $(ect).removeClass(_this.allClasses);
                $(ect).addClass($(ect).val());
                $(el).find('.t1-toggles button').removeClass('active');

                _this.updateOptions();
            });
            $(el).find('.t1-toggles button').each(function (i, button) {
                var $button = $(button);
                $button.off('click').on('click', function (e) {
                    e.stopImmediatePropagation();
                    $('.t1-bundle-select-list').removeClass('visible');
                    $(e.currentTarget).toggleClass('active');

                    _this.updateOptions();

                    $(el).find('select').val("");
                    e.preventDefault();

                    _this.updateArias();

                    $(e.currentTarget).blur();
                });
            });
            this.updateArias();
        }

        //$(this.bundler).find('.t1-zip').on('focusin', function (e) {
        //    var ect = e.currentTarget;
        //    $(ect).val('').parent().addClass('editing');
        //});
        //$(this.bundler).find('.t1-zip').on('focusout', function (e) {
        //    var $ect = $(e.currentTarget);
        //    $ect.parent().removeClass('editing');

        //    if (_this.isValidZip($ect.val())) {
        //        $ect.parent().removeClass('invalid');
        //        $(_this.bundler).find('.t1-get-a-quote').removeAttr('disabled');
        //    } else {
        //        $ect.parent().addClass('invalid');
        //        $(_this.bundler).find('.t1-get-a-quote').attr('disabled', 'disabled');
        //    }
        //});
        $(this.bundler).find('.t1-zip').on('keyup', function (e) {
            if (e.keyCode === 13) {
                $(e.currentTarget).blur();
            }
        });
        $(this.bundler).find('.t1-remove-product').off('click').on('click', function (e) {
            e.stopImmediatePropagation();
            var ect = e.currentTarget;
            $(ect).parent().remove();

            _this.updateOptions();
        });
        //$(this.bundler).find('.t1-get-a-quote').off('click').on('click', function (e) {
        //    e.preventDefault();
        //   // location.replace(_this.getURL());
        //   // $('#modalEditLocationOverlay').modal('show');
        //    $('#modalEditLocationOverlay').modal('show'); ProcessMetrics('ZipOverlayEdit', ['Zip Overlay Edit', 'MainNav']); $(Global.zipCodeOverlayIdentifier).data({ 'quoteProduct': 'Au', 'quoteCampaign': '/home/home.aspx?fake=|MainNav|quote_box:Au', 'component': 'GlobalNavigation' }).dialog('open');
        //});

        if (this.type !== 'v2') {
            this.showAddProduct();
        } else {
            this.swapSelects();
            this.updateSwaps();
        }
    }

    _createClass(BundleSelector, [{
        key: "swapSelects",
        value: function swapSelects() {
            var $selects = $(this.bundler).find('select').not('.t1-bundle-select-wrap select');
            $selects.each(function (i, select) {
                var $select = $(select);
                $select.wrap('<div class="t1-bundle-select-wrap"></div>');
                var $wrap = $select.parent();
                $wrap.append('<ul class="t1-bundle-select-list"></ul><div class="t1-bundle-select-list-selected"></div>');
                $wrap.find('.t1-bundle-select-list-selected').off('click').on('click', function (e) {
                    var $selected = $(e.currentTarget);

                    if ($selected.prev('.t1-bundle-select-list').find('li').length > 0) {
                        $selected.prev('.t1-bundle-select-list').toggleClass('visible');
                    }

                    $('.t1-bundle-select-list').not($selected.prev('.t1-bundle-select-list')).removeClass('visible');
                });
            });
        }
    }, {
        key: "updateSwaps",
        value: function updateSwaps() {
            var _this2 = this;

            $(this.bundler).find('.t1-bundle-select-wrap').each(function (i, wrap) {
                var $wrap = $(wrap);
                var $list = $(wrap).find('.t1-bundle-select-list');
                var $select = $(wrap).find('select');
                var $selected = $(wrap).find('.t1-bundle-select-list-selected');
                $list.empty();
                $select.children('option').each(function (i, option) {
                    var $option = $(option);
                    var selval = $select.val();

                    if (selval === null) {
                        selval = $select.children().first().val();
                    }

                    if ($option.val() == selval) {
                        $selected.text($option.text());

                        if (selval == "") {
                            $selected.removeClass(_this2.allClasses).addClass('add-product');
                        } else {
                            $selected.removeClass('add-product').removeClass(_this2.allClasses).addClass($option.val());
                        }
                    } else {
                        if ($option.val() !== '') {
                            $list.append('<li data-value="' + $option.val() + '" class="' + $option.val() + '">' + $option.text() + '</li>');
                        }
                    }
                });
            });
            $(this.bundler).find('.t1-bundle-select-list li').off('click').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var $opt = $(e.currentTarget);
                $opt.parent().parent().find('select').val($opt.data('value')).change();
                $('.t1-bundle-select-list').removeClass('visible');

                _this2.showAddProduct();

                _this2.updateSwaps();
            });
            $(this.bundler).find('.t1-bundle-select-list-selected').each(function (i, selected) {
                var $selected = $(selected);

                if ($selected.prevAll('select').is(':visible')) {
                    $selected.show();
                } else {
                    $selected.hide();
                }

                ;
            });
        }
    }, {
        key: "updateArias",
        value: function updateArias() {
            var names = {
                'Au': 'Auto Insurance',
                'Ho': 'Home Insurance',
                'Re': 'Renters Insurance',
                'Li': 'Life Insurance'
            };
            $(this.bundler).find('.t1-toggles button').each(function (i, button) {
                var name = names[$(button).data('value')];

                if ($(button).hasClass('unavailable')) {
                    $(button).attr('aria-label', name + ' not available in this bundle.');
                } else if ($(button).hasClass('active')) {
                    $(button).attr('aria-label', name + ' is selected.');
                } else {
                    $(button).attr('aria-label', 'Select ' + name);
                }
            });
        }
    }, {
        key: "optionsWith",
        value: function optionsWith(vals) {
            var _this3 = this;

            var moreOptions = [];

            if (vals.length !== 0) {
                this.combos.forEach(function (combo) {
                    if (_this3.containsAll(vals, combo)) {
                        var remainingOptions = combo;
                        vals.forEach(function (val) {
                            remainingOptions = remainingOptions.filter(function (e) {
                                return e !== val;
                            });
                        });
                        moreOptions = moreOptions.concat(remainingOptions);
                    }
                });
            } else {
                moreOptions = this.allOptions;
            }

            return moreOptions;
        }
    }, {
        key: "showAddProduct",
        value: function showAddProduct() {
            var moreOptions = this.optionsWith(this.currentVals());

            if (moreOptions.length > 0) {
                var appendText = '<option value="" selected="selected" disabled="disabled">+ Add another product to save</option>';

                var _iterator = _createForOfIteratorHelper(this.optionsMap.entries()),
                    _step;

                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var _step$value = _slicedToArray(_step.value, 2),
                            key = _step$value[0],
                            value = _step$value[1];

                        if ($.inArray(key, moreOptions) > -1) {
                            appendText += '<option value="' + key + '">' + value + '</option>';
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }

                $(this.bundler).find('.t1-add-product').hide().empty().last().append(appendText).show();
            } else {
                $(this.bundler).find('.t1-add-product').empty().hide();
            }

            if (this.type == 'v1' && this.type != 'mobile') {
                this.swapSelects();
                this.updateSwaps();
            }
        }
    }, {
        key: "updateOptions",
        value: function updateOptions() {
            //$(this.bundler).find('.t1-retrieve').hide();
            this.showAddProduct();
            this.setAvailableOptions();
        }
    }, {
        key: "getProducts",
            value: function getProducts() {
            var vals = this.currentVals();
            var firstval = vals[0];
            var url = '';
            //var zip = $(this.bundler).find('.t1-zip').val();
            var intcid = '&intcid=' + Global.SCPageName + '|MainNav|quote_box:' + vals.join('-') + "&Mobile=Y";
            //"/anon/handlers/quoteactivity.ashx?product=" + productCode + "&intcid=/home/home.aspx|MainNav|quote_box:" + productCode + "&Mobile=Y"
            //if (vals.length > 1 || $.inArray(firstval, ['Au', 'Ho', 'Re', 'Li']) > -1) {
            //    url = 'https://purchase.allstate.com/onlineshopping/?zipcode=' + zip + '&Product=' + vals.join('-') + intcid;
            //} else {
            //    url = '/anon/handlers/quoteactivity.ashx?product=' + firstval + '&zip=' + zip + intcid;
            //}

            if (vals.length > 1 || $.inArray(firstval, ['Au', 'Ho', 'Re', 'Li']) > -1) {
                url = vals.join('-');
            }
               else
                url = firstval;
            return url;
        }
    }, {
        key: "setAvailableOptions",
        value: function setAvailableOptions() {
            var _this4 = this;

            if (this.type == 'v1' || this.type == 'mobile') {
                $(this.bundler).find('select.t1-bundle-select').not('.t1-bundle-container:first-child select.t1-bundle-select').each(function (i, e) {
                    var gaqOptions = _this4.optionsWith(_this4.except(_this4.currentVals(), $(e).val()));

                    var appendText = '';

                    var _iterator2 = _createForOfIteratorHelper(_this4.optionsMap.entries()),
                        _step2;

                    try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                            var _step2$value = _slicedToArray(_step2.value, 2),
                                key = _step2$value[0],
                                value = _step2$value[1];

                            if (key == $(e).val()) {
                                appendText += '<option value="' + key + '" selected="selected">' + value + '</option>';
                            } else if ($.inArray(key, gaqOptions) > -1) {
                                appendText += '<option value="' + key + '">' + value + '</option>';
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally {
                        _iterator2.f();
                    }

                    $(e).empty().append(appendText);
                });

                if (this.type == 'v1' && this.type != 'mobile') {
                    this.swapSelects();
                    this.updateSwaps();
                }
            } else {
                var vals = this.currentVals();
                var toggles = ['Au', 'Ho', 'Re', 'Li'];
                var toggleVals = vals.filter(function (val) {
                    return toggles.indexOf(val) != -1;
                });

                if (vals.length < 1) {
                    //$(this.bundler).find('.t1-get-a-quote').attr('disabled', 'disabled');
                } else {
                    //$(this.bundler).find('.t1-get-a-quote').removeAttr('disabled');
                }

                if (toggleVals.length > 0) {
                    $(this.bundler).find('select').val('');
                }

                if (vals.indexOf('Ho') != -1) {
                    $(this.bundler).find('.t1-toggles button[data-value="Re"]').addClass('unavailable').removeClass('active');
                } else if (vals.indexOf('Re') != -1) {
                    $(this.bundler).find('.t1-toggles button[data-value="Ho"]').addClass('unavailable').removeClass('active');
                } else {
                    $(this.bundler).find('.t1-toggles button').removeClass('unavailable');
                }

                this.updateSwaps();
            }
        }
    }, {
        key: "getAttr",
        value: function getAttr() {
            var vals = this.currentVals();
            var attr = '';

            if (vals.indexOf('Au') !== -1) {
                attr = attr + '_Auto';
            }

            if (vals.indexOf('Ho') !== -1) {
                attr = attr + '_Home';
            }

            if (vals.indexOf('Re') !== -1) {
                attr = attr + '_Renters';
            }

            if (vals.indexOf('Li') !== -1) {
                attr = attr + '_Life';
            }

            if (vals.indexOf('Co') !== -1) {
                attr = attr + '_Condo';
            }

            if (vals.indexOf('Mo') !== -1) {
                attr = attr + '_Motorcycle';
            }

            if (vals.indexOf('Bo') !== -1) {
                attr = attr + '_Boat';
            }

            if (vals.indexOf('RV') !== -1) {
                attr = attr + '_ATV';
            }

            if (vals.indexOf('BI') !== -1) {
                attr = attr + '_Business';
            }

            return attr.substr(1, attr.length);
        }
    }, {
        key: "currentVals",
        value: function currentVals() {
            var vals = [];

            if (this.type == 'v1' || this.type == 'mobile') {
                $(this.bundler).find('select').each(function (i, e) {
                    var val = $(e).val();

                    if (val !== null && val !== "") {
                        vals.push(val);
                    }
                });
            } else {
                $(this.bundler).find('.t1-toggles button.active').each(function (i, e) {
                    var val = $(e).data('value');
                    vals.push($(e).data('value'));
                });

                if (vals.length < 1 && $(this.bundler).find('select').val() != "") {
                    vals.push($(this.bundler).find('select').val());
                }
            }

            return vals;
        }
    }, {
        key: "containsAll",
        value: function containsAll(needles, haystack) {
            for (var i = 0, len = needles.length; i < len; i++) {
                if ($.inArray(needles[i], haystack) == -1) return false;
            }

            return true;
        }
    }, {
        key: "except",
        value: function except(arr, val) {
            return arr.filter(function (e) {
                return e != val;
            });
        }
    }, {
        key: "isValidZip",
        value: function isValidZip(zip) {
            return /^[0-9]{5}(?:-[0-9]{4})?$/.test(zip);
        }
    }]);

    return BundleSelector;
}();

$(document).ready(function () {
    setTimeout(function () {
        $(document).click(function (event) {
            var $target = $(event.target);

            if (!$target.closest('.t1-bundle-select-wrap').length) {
                $('.t1-bundle-select-list').removeClass('visible');
            }
        });
        $('.t1').each(function (i, m) {
            var unused = new BundleSelector($(m));
        });
        $('.t1 .t1-bundle-select-list-selected').show();
    }, 100);
});